module.exports={
	"Form": "AssetClassificationCreateManifest",
	"Scope": "AssetClassification-Create",
	"Descriptors":
	{
		"AssetClassificationDetails.Name":
		{
			"Name": "Name",
			"Hash": "AssetClassification-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "AssetClassification-Create-Identity",
				"Group": "AssetClassification-Create-Identity"
			}
		},
		"AssetClassificationDetails.Description":
		{
			"Name": "Description",
			"Hash": "AssetClassification-Create-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "2",
				"Width": 12,
				"Section": "AssetClassification-Create-Details",
				"Group": "AssetClassification-Create-Details"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "AssetClassification-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "AssetClassification-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "AssetClassification-Create-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "AssetClassification-Create-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
